export const phoneNumberVerification = (number: string): boolean => {
  const reg = /^1[3-9]\d{9}$/;
  return reg.test(number);
};
